import BaseComponent from './BaseComponent';
import cookieValue from './helper/cookieValue';
import setCookie from './helper/setCookie';

/**
 * Full snapshot of all diocese toggles (required + optional) for cookie storage.
 */
const buildDioceseCategoriesFromDom = (rootEl, selector) => {
    const categories = {};
    rootEl.querySelectorAll(`#${selector} input`).forEach((checkbox) => {
        categories[checkbox.value] = checkbox.checked;
    });
    return categories;
};

const isTruthyCookieValue = (value) => value === true || value === 'true' || value === 1 || value === '1';

const syncDioceseUrlParams = (urlParams, selector, checkboxes) => {
    urlParams.delete(`${selector}[]`);
    checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
            urlParams.append(`${selector}[]`, checkbox.value);
        }
    });
};

class NewsList extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;
        this.expirationDays = parseInt(el.dataset.expirationDays || '30', 10);
        this.urlParams = new URLSearchParams(window.location.search);
        // Ensures Fusion Ajax.newsListFragment matches when dioceses[] is empty (all unchecked)
        this.urlParams.set('newsListFragment', '1');
        this.handleCheckboxes(el, 'dioceses');
        this.handlePagination();
    }

    handleCheckboxes(el, selector) {
        const checkboxes = this.el.querySelectorAll(`#${selector} input`);
        const hasPreferencesConsent = window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.preferences;
        const cookie = hasPreferencesConsent ? cookieValue('newsCategories') : null;
        const hasCookieSelection = !!(cookie && cookie.categories && typeof cookie.categories === 'object');

        if (hasCookieSelection) {
            checkboxes.forEach((checkbox) => {
                checkbox.checked = isTruthyCookieValue(cookie.categories[checkbox.value]);
            });
        }

        this.urlParams.delete(`${selector}[]`);
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                this.urlParams.append(`${selector}[]`, checkbox.value);
            }
        });

        if (hasCookieSelection) {
            fetch(`?${this.urlParams}`)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    el.querySelector('.list-teaser').innerHTML = html;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        }

        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
                // Only set cookie if accepted cookie consent — replace categories with full current state
                if (window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.preferences) {
                    setCookie('newsCategories', {
                        categories: buildDioceseCategoriesFromDom(this.el, selector),
                        updated: Date.now(),
                    }, this.expirationDays);
                }

                syncDioceseUrlParams(this.urlParams, selector, checkboxes);

                fetch(`?${this.urlParams}`)
                    .then(function (response) {
                        if (response.ok) {
                            return response.text();
                        }
                        return Promise.reject(response);
                    })
                    .then(function (html) {
                        el.querySelector('.list-teaser').innerHTML = html;
                    })
                    .catch(function (error) {
                        console.warn(error);
                    });
            });
        });
    }

    handlePagination() {
        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('#news-load-more')) {
                return;
            }
            e.preventDefault();
            e.target.classList.add('is-active');
            this.urlParams.set('offset', e.target.dataset.offset);
            fetch(`?${this.urlParams}`)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    e.target.outerHTML = html;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }
}

export default NewsList;
